import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './errors';

/**
 * Odds and balances go stale fast, so defaults are deliberately short-lived and
 * refetch on focus. Feature hooks override these where the data is slower moving
 * (sport lists, CMS content) or pushed over the feed (live odds).
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: true,
        retry: (failureCount, error) => {
          // A rejected or missing request will fail the same way when repeated.
          if (error instanceof ApiError && !error.isRetryable) return false;
          return failureCount < 2;
        },
        retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
      },
      mutations: {
        // Placing a bet twice is worse than showing an error, so never retry.
        retry: false,
      },
    },
  });
}

export const queryClient = createQueryClient();
